import * as Ladda from "ladda"
import PropTypes from "prop-types"
import React from "react"
let TrackableLink

export default TrackableLink = ({
  className,
  tracking_event,
  tracking_element,
  on_click,
  children,
  ladda,
  href
}) => {
  const link_element = React.useRef(null)
  const [link_clicked, set_link_clicked] = React.useState(false)
  const on_link_click = (e) => {
    if (link_clicked) return
    set_link_clicked(true)
    const loader = ladda && Ladda.create(link_element.current).start()
    on_click?.(e)?.catch?.(() => {
      loader?.stop()
      set_link_clicked(false)
    })
  }
  return (
    <a
      ref={link_element}
      href={href}
      className={className}
      data-track={tracking_event}
      data-track-element={tracking_element}
      data-style={ladda || undefined}
      onClick={on_link_click}>
      {children}
    </a>
  )
}

TrackableLink.propTypes = {
  className: PropTypes.string,
  tracking_event: PropTypes.string.isRequired,
  tracking_element: PropTypes.string,
  on_click: PropTypes.func,
  children: PropTypes.node.isRequired,
  ladda: PropTypes.string,
  href: PropTypes.string
}
